import { render } from "./DiceRoller.vue?vue&type=template&id=0c59a56f&scoped=true"
import script from "./DiceRoller.vue?vue&type=script&lang=js"
export * from "./DiceRoller.vue?vue&type=script&lang=js"

import "./DiceRoller.vue?vue&type=style&index=0&id=0c59a56f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shavin\\Documents\\apps\\10-candles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c59a56f"]])

export default __exports__